/** How long the one-time "call controls are here" tooltip stays on the chip. */
export const CALL_CONTROLS_HINT_MS = 4000;
